import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ENDPOINTS } from './../../endpoints';
import { useMemo } from 'react';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import { formatISO } from 'date-fns';
import useServices from '../../hooks/useServices';

var ServiceRWMembers = /*#__PURE__*/function (_Service) {
  _inherits(ServiceRWMembers, _Service);

  var _super = _createSuper(ServiceRWMembers);

  function ServiceRWMembers() {
    _classCallCheck(this, ServiceRWMembers);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceRWMembers, [{
    key: "fetchRWMembers",
    value: function fetchRWMembers(_ref) {
      var limit = _ref.limit,
          offset = _ref.offset,
          roles = _ref.roles,
          excludingUserId = _ref.excludingUserId,
          searchVector = _ref.searchVector;
      var params = roles ? {
        role: roles
      } : {
        limit: limit,
        offset: offset
      };
      params.excluding_user_id = excludingUserId;
      params.search_vector = searchVector;
      return this.axiosInstance.get(ENDPOINTS.rwMembers.root, {
        params: params
      });
    }
  }, {
    key: "createRwMember",
    value: function createRwMember(data) {
      return this.axiosInstance.post(ENDPOINTS.rwMembers.root, data);
    }
  }, {
    key: "updateRwMember",
    value: function updateRwMember(rwMemberId, data) {
      return this.axiosInstance.put("".concat(ENDPOINTS.rwMembers.root, "/").concat(rwMemberId), data);
    }
  }, {
    key: "fetchRoles",
    value: function fetchRoles(_ref2) {
      var user_id = _ref2.user_id;
      return this.axiosInstance.get("".concat(ENDPOINTS.rwMembers.root, "/roles"), {
        params: {
          id: user_id
        }
      });
    }
  }, {
    key: "fetchAvailableRoles",
    value: function fetchAvailableRoles() {
      return this.axiosInstance.get("".concat(ENDPOINTS.rwMembers.root, "/available_roles"));
    }
  }, {
    key: "deleteRwMember",
    value: function deleteRwMember(rwMemberId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.rwMembers.root, "/").concat(rwMemberId));
    }
  }, {
    key: "getWallet",
    value: function getWallet(_ref3) {
      var csmId = _ref3.csmId,
          referenceDate = _ref3.referenceDate;
      return this.axiosInstance.get(ENDPOINTS.rwMembers.wallet, {
        params: {
          csm_id: csmId,
          date: referenceDate ? formatISO(referenceDate, {
            representation: 'date'
          }) : undefined
        }
      });
    }
  }, {
    key: "getActiveApplications",
    value: function getActiveApplications(_ref4) {
      var csmId = _ref4.csmId,
          count = _ref4.count,
          limit = _ref4.limit,
          offset = _ref4.offset,
          category = _ref4.category;
      return this.axiosInstance.get(ENDPOINTS.rwMembers.activeApplications, {
        params: {
          csm_id: csmId,
          count: count,
          limit: limit,
          offset: offset,
          category: category
        }
      });
    }
  }, {
    key: "getAgenda",
    value: function getAgenda(_ref5) {
      var day = _ref5.day,
          rwMemberId = _ref5.rwMemberId,
          overdue = _ref5.overdue,
          nextWeek = _ref5.nextWeek,
          monthlyWorkload = _ref5.monthlyWorkload,
          orderBy = _ref5.orderBy;
      return this.axiosInstance.get(ENDPOINTS.rwMembers.agenda, {
        params: {
          rw_member_id: rwMemberId,
          day: day,
          overdue: overdue,
          next_week: nextWeek,
          monthly_workload: monthlyWorkload,
          order_by: orderBy !== null && orderBy !== void 0 && orderBy.variable ? "".concat(orderBy.order, ":").concat(orderBy.variable) : undefined
        }
      });
    }
  }, {
    key: "getAssociatedTasks",
    value: function getAssociatedTasks(_ref6) {
      var referentContactId = _ref6.referentContactId,
          csmId = _ref6.csmId;
      return this.axiosInstance.get(ENDPOINTS.rwMembers.associatedTasks, {
        params: {
          csm_id: csmId,
          referent_contact_id: referentContactId
        }
      });
    }
  }, {
    key: "getRwMemberWorkload",
    value: function getRwMemberWorkload(_ref7) {
      var lowestWorkload = _ref7.lowestWorkload;
      return this.axiosInstance.get(ENDPOINTS.rwMembers.workload, {
        params: {
          lowest_workload: lowestWorkload
        }
      });
    }
  }, {
    key: "getRestaurantReferentAssociatedTasks",
    value: function getRestaurantReferentAssociatedTasks(_ref8) {
      var referentUserContactIds = _ref8.referentUserContactIds,
          csmId = _ref8.csmId;
      return this.axiosInstance.get(ENDPOINTS.rwMembers.associatedTasks, {
        params: {
          csm_id: csmId,
          referent_user_contact_ids: referentUserContactIds
        }
      });
    }
  }]);

  return ServiceRWMembers;
}(Service);

export function useRwMembersService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceRWMembers(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useRwMembersService;
export * from './types';